import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="back-nav">
          <Link to="/" className="back-btn">← Back to Home</Link>
        </div>
        <header className="policy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="policy-content">
          <section>
            <h2>1. Introduction</h2>
            <p>
              SpendsMate ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and services.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We collect the following personal information to provide our services:</p>
            <ul>
              <li><strong>Name:</strong> To identify you within the app and for expense sharing</li>
              <li><strong>Phone Number:</strong> For account verification, notifications, and expense settlements</li>
              <li><strong>Email Address:</strong> For account management, notifications, and customer support</li>
              <li><strong>UPI ID:</strong> To facilitate direct money transfers and cashback payments</li>
            </ul>

            <h3>Usage Information</h3>
            <ul>
              <li>Expense data and transaction history</li>
              <li>App usage patterns and preferences</li>
              <li>Device information and identifiers</li>
              <li>Location data (when permitted) for expense categorization</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use your information for:</p>
            <ul>
              <li>Providing expense splitting and tracking services</li>
              <li>Processing cashback payments to your account</li>
              <li>Sending notifications about expense settlements and app updates</li>
              <li>Improving our services and user experience</li>
              <li>Preventing fraud and ensuring security</li>
              <li>Complying with legal obligations under Indian law</li>
            </ul>
          </section>

          <section>
            <h2>4. Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Other Users:</strong> Your name and expense details with friends you choose to split expenses with</li>
              <li><strong>Payment Partners:</strong> UPI ID and transaction details for processing payments and cashbacks</li>
              <li><strong>Service Providers:</strong> Third-party services that help us operate our app (with strict confidentiality agreements)</li>
              <li><strong>Legal Authorities:</strong> When required by Indian law or to protect our rights</li>
            </ul>
            <p>We do not sell your personal information to third parties.</p>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your information, including:
            </p>
            <ul>
              <li>Encryption of sensitive data in transit and at rest</li>
              <li>Secure servers and regular security audits</li>
              <li>Limited access to personal information on a need-to-know basis</li>
              <li>Compliance with RBI guidelines for payment data</li>
            </ul>
          </section>

          <section>
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to provide our services and comply with legal obligations. You may request deletion of your account and associated data at any time.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>Under Indian data protection laws, you have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and data</li>
              <li>Withdraw consent for data processing</li>
              <li>Port your data to another service</li>
            </ul>
          </section>

          <section>
            <h2>8. Cookies and Tracking</h2>
            <p>
              Our app may use cookies and similar technologies to enhance user experience and analyze usage patterns. You can manage cookie preferences in your device settings.
            </p>
          </section>

          <section>
            <h2>9. Third-Party Services</h2>
            <p>
              Our app integrates with UPI payment systems and may use third-party analytics services. These services have their own privacy policies, and we encourage you to review them.
            </p>
          </section>

          <section>
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are not intended for children under 18. We do not knowingly collect personal information from children under 18 years of age.
            </p>
          </section>

          <section>
            <h2>11. Changes to Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any material changes through the app or via email.
            </p>
          </section>

          <section>
            <h2>12. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> privacy@spendsmate.com</p>
              <p><strong>Address:</strong> SpendsMate Technologies, India</p>
            </div>
          </section>

          <section>
            <h2>13. Governing Law</h2>
            <p>
              This Privacy Policy is governed by the laws of India, including the Information Technology Act, 2000, and the Personal Data Protection Bill (when enacted).
            </p>
          </section>
        </div>

        <div className="policy-footer">
          <p>
            By using SpendsMate, you acknowledge that you have read and understood this Privacy Policy and agree to the collection and use of your information as described herein.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;